var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.7158203,28.9697266C37.7001953,27.8603516,31.519043,26,24,26c-7.6508789,0-13.9135742,2.1533203-16.9658203,3.4365234 C5.190918,30.2119141,4,32.0166016,4,34.0341797V46h2V34.0341797c0-1.2109375,0.7104492-2.2919922,1.8095703-2.7539062 C10.7226562,30.0546875,16.699707,28,24,28c7.2089844,0,13.1347656,1.7832031,16.0253906,2.8466797 C41.206543,31.28125,42,32.4150391,42,33.6669922V46h2V33.6669922C44,31.5800781,42.6801758,29.6923828,40.7158203,28.9697266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,24c4.1123047,0,8-5.831543,8-12c0-8.2651367-4.3505859-10-8-10s-8,1.7348633-8,10C16,18.168457,19.8876953,24,24,24z  M24,4c4.0375977,0,6,2.6166992,6,8c0,5.2915039-3.3554688,10-6,10s-6-4.7084961-6-10C18,6.6166992,19.9624023,4,24,4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMedium);
export default __webpack_public_path__ + "static/media/account--medium.62876c6e321777fd2b219cc863bd7dde.svg";
export { ForwardRef as ReactComponent };